<template>

  <div>

  <v-container>

    <v-layout class="flex-column" align-center>
      <v-subheader class="headline font-weight-bold mb-3">
        {{ title }}
      </v-subheader>

      <v-card class="pa-5 mb-5">
        <span v-html="$store.getters.getChallengeDescription"></span>
      </v-card>

      <div
        class="d-flex flex-column treasure-map-terminal-container"
      >

        <v-tabs
          fixed-tabs
          background-color="indigo"
          dark
          v-model="activeTab"
          v-if="$store.getters.isLabStarted"
        >
          <v-tab
            @click="setSelectedWindow('treasure-map')"
          >
            <v-icon left>
              mdi-flag-outline
            </v-icon>
            Treasure Map
          </v-tab>
          <v-tab
            @click="setSelectedWindow('terminal')"
          >
            <v-icon left>
              mdi-iframe-outline
            </v-icon>
            Terminal View
          </v-tab>
        </v-tabs>

        <!--div
          class="toggle-btn-container"
          v-if="$store.getters.isLabStarted"
        >

          <v-btn
            value="treasure-map"
            @click="setSelectedWindow('treasure-map')"
          >
            <v-icon left>
              mdi-flag-outline
            </v-icon>
            Treasure Map
          </v-btn>

          <v-btn
            value="terminal"
            @click="setSelectedWindow('terminal')"
          >
            <v-icon left>
              mdi-iframe-outline
            </v-icon>
            Terminal View
          </v-btn>

        </div-->

        <div
          :class="[selectedWindow === 'terminal' ? 'flip' : '', doTransformAnimation ? 'flip-container' : '']"
        >
          <div :class="doTransformAnimation ? 'flipper' : ''">

            <div :class="doTransformAnimation ? 'front' : ''">

              <FlagMap
                v-show="selectedWindow === 'treasure-map'"
              >
              </FlagMap>

            </div>

            <div
              :class="doTransformAnimation ? 'back' : ''"
            >

              <Terminal
                v-show="selectedWindow === 'terminal'"
                :class="selectedWindow === 'terminal' ? 'flip' : ''"
                :reset="resetTerminals"
                :terminalWidth="windowWidth"
                :terminalHeight="windowHeight"
                @set-transform-animations="setTransformAnimationState"
              >
              </Terminal>

            </div>
          </div>
        </div>

      </div>

      <v-row
        v-if="!this.$store.getters.isLabStarted"
        class="d-flex flex-column mt-1"
      >

        <v-col>

          <v-row class="d-flex flex-row">

            <v-col
              :style="{ visibility: hideZonesDropDown ? 'hidden' : 'visible' }"
            >

              <v-menu
                close-on-click
                close-on-content-click
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    large
                    color="primary"
                    dark
                    v-on="on"
                  >
                    {{ zone }}
                    <v-icon right>
                      mdi-menu-down
                    </v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item
                    class="text-center"
                    v-for="(zone, index) in zones"
                    :key="index"
                    @click="setZone(index)"
                  >
                    <v-list-item-title>{{ zone }}</v-list-item-title>
                  </v-list-item>
                </v-list>

              </v-menu>
            
            </v-col>
            
            <v-col>

              <v-btn
                v-if="!startingLab"
                rounded
                class="ml-3"
                large
                color="primary"
                @click="verifyCaptchaAndStartTheLab()"
              >
                <v-icon left>
                  mdi-play
                </v-icon>

                Start Lab

              </v-btn>

              <v-btn
                v-else
                rounded
                class="ml-3"
                large
                color="primary"
                :pressed="!startingLab"
              >
                Starting...
                <v-icon
                  right
                  dark
                  small
                  class="custom-loader"
                >
                  mdi-settings
                </v-icon>
              </v-btn>

            </v-col>

          </v-row>

        </v-col>

        <v-col class="d-flex justify-center">

          <recaptcha
            ref="recaptcha"
            @verify="submit"
          >
          </recaptcha>

        </v-col>

      </v-row>

      <v-row v-else
        class="d-flex flex-column mt-3"
      >

        <v-col>

          <v-row class="d-flex flex-row">

            <v-col>

              <v-btn
                rounded
                large
                class="ml-3"
                color="success"
                @click="launchLab()"
              >
                Lab Link
                <v-icon right>mdi-open-in-new
                </v-icon>
              </v-btn>

            </v-col>
            
            <v-col>

              <v-btn
                v-if="!stoppingLab"
                rounded
                large
                class="ml-3"
                dark
                color="red"
                @click="stopLab()"
                :pressed="stoppingLab"
              >
                <v-icon left>
                  mdi-stop
                </v-icon>

                Stop Lab

              </v-btn>

              <v-btn
                v-else
                rounded
                large
                class="ml-3"
                dark
                color="red"
                :pressed="stoppingLab"
              >
                Stopping...
                <v-icon
                  right
                  dark
                  small
                  class="custom-loader"
                >
                  mdi-settings
                </v-icon>
              </v-btn>

            </v-col>

          </v-row>

        </v-col>

      </v-row>

      <div
        v-if="error"
        class="red--text font-weight-bold"
      >
        {{ error }}
      </div>

    </v-layout>

  </v-container>

  </div>

</template>

<script>

import FlagMap from "@/components/FlagMap.vue";
import Recaptcha from "@/components/Recaptcha.vue";
import Terminal from "@/components/Terminal.vue";

export default {
  name: "Challenge",
  props: {
    title: String,
    image: String,
    labid: String
  },
  components: {
    FlagMap,
    Recaptcha,
    Terminal
  },
  data() {
    return {
      done: false,
      zoneString: "Select Server Zone",
      zone: null,
      zones: [
        "Asia",
        "Europe",
        "US"
      ],
      error: null,
      startingLab: false,
      stoppingLab: false,
      hideZonesDropDown: false,
      resetTerminals: false,
      windowWidth: 950,
      windowHeight: 550,
      selectedWindow: 'treasure-map',
      model: "front",
      scalingFactor: 1,
      doTransformAnimation: true,
      activeTab: 0,
    };
  },
  created() {
    this.zone = this.zoneString;

    this.windowWidth = 800; // this.scalingFactor * window.innerWidth;
    this.windowHeight = 500; // this.scalingFactor * window.innerHeight;

    this.doesLabExists();
  },
  methods: {
    submit(captchaToken) {

      this.error = null;
      this.$store.dispatch("resetState");
      this.$store.dispatch("setCaptchaToken", captchaToken);

    },
    setTransformAnimationState(state) {

      this.doTransformAnimation = state;

    },
    setSelectedWindow(window) {

      if (window === 'terminal') {
        this.activeTab = 1;
      }
      else {
        this.activeTab = 0;
      }

      this.selectedWindow = window;

    },
    setZone(idx) {

      this.error = null;
      this.zone = this.zones[idx];

    },
    resetLabsStatus() {

      this.startingLab = false;
      this.stoppingLab = false;
      this.hideZonesDropDown = false;
      this.error = null;

      this.resetTerminals = true;
      setTimeout(() => this.resetTerminals = false, 1000);

      this.$store.dispatch("setLabStartState", false);

    },
    verifyCaptchaAndStartTheLab() {

      this.resetLabsStatus();

      if (this.$store.getters.getCaptchaToken === null) {
        this.error = "Please solve the CAPTCHA first...";
        return;
      }

      if (this.zone === this.zoneString) {
        this.error = "Please select a server zone from the list...";
        return;
      }

      let headers = {
        "Content-Type": "application/json"
      };

      let data = {
        "operation": "start",
        "token": this.$store.getters.getCaptchaToken,
        "labid": this.labid,
        "zone": this.zone
      };

      if (this.startingLab === true) {
        this.error = "Please wait. Starting the lab...";
        return;
      }

      this.startingLab = true;
      this.hideZonesDropDown = true;

      this.$axios
      .post("/labs", data, { headers })
        .then(response => {
          /* eslint-disable no-console */
          console.log(JSON.stringify(response.data));

          this.resetLabsStatus();

          this.zone = this.zoneString;
          this.$refs.recaptcha.reset();

          if ("url" in response.data && "cid" in response.data) {
            this.$store.dispatch("setLabURL", "http://" + response.data["url"]);
            this.$store.dispatch("setLabCID", response.data["cid"]);

            this.$store.dispatch("setLabStartState", true);

            this.error = null;

            this.setSelectedWindow("terminal");
          }

          if ("error" in response.data) {
            this.error = response.data["error"];
          }

          /* eslint-enable no-console */
        })
        .catch(error => {
          /* eslint-disable no-console */
          console.log(error);
          this.resetLabsStatus();
          /* eslint-enable no-console */
        })
        .finally(function() {
        });

    },
    launchLab() {
      if (this.$store.getters.getLabURL) {
        window.open(this.$store.getters.getLabURL, "_blank");
      }
    },
    stopLab() {

      this.error = null;

      this.zone = this.zoneString;

      if (!(this.$store.getters.isLabStarted && this.$store.getters.getLabURL && this.$store.getters.getLabCID)) {

        this.error = "Lab not started yet!";
        this.resetLabsStatus();
        return;

      }

      let headers = {
        "Content-Type": "application/json"
      };

      let data = {
        "operation": "stop",
        "cid": this.$store.getters.getLabCID
      };

      this.stoppingLab = true;

      this.$axios
      .post("/labs", data, { headers })
        .then(response => {
          /* eslint-disable no-console */
          console.log(JSON.stringify(response.data));

          this.stoppingLab = false;

          if ("error" in response.data) {
            // The error if any is:
            // the lab is already stopped or no
            // such lab exists!
            // So avoiding to display that!

            // this.error = response.data["error"];
            this.resetLabsStatus();

            // Remove the Lab URL and Lab CID from the VueX store.
            this.$store.dispatch("resetState");
          }
          else if ("status" in response.data) {
            // Assuming we succeeded!
            // Setting captcha solved to false since we had already played the lab
            // and stopped the lab just now!

            // We don't have anything to be done here!
            this.resetLabsStatus();

            // Remove the Lab URL and Lab CID from the VueX store.
            this.$store.dispatch("resetState");
          }

          // this.$store.dispatch("resetState");

          /* eslint-enable no-console */
          window.onbeforeunload = null;
          this.setSelectedWindow("treasure-map");
        })
        .catch(error => {
          /* eslint-disable no-console */
          console.log(error);
          this.error = error;
          /* eslint-enable no-console */
        })
        .finally(function() {
        });
    },
    doesLabExists() {

      if (!this.$store.getters.getLabCID) {
        this.resetLabsStatus();
        return;
      }

      this.$axios
      .get("/checklab?cid=" + this.$store.getters.getLabCID)
        .then(response => {
          if ("status" in response.data && response.data["status"] === "fail") {
            // Lab does not exists!
            this.$store.dispatch("resetState");
            this.error = null;
          }
          else if ("status" in response.data && response.data["status"] === "success") {
            // Lab does exists!
            // Continue!
            this.error = null;
          }
        })
        .catch(error => {
          /* eslint-disable no-console */
          console.log(error);
          /* eslint-enable no-console */
        })
        .finally(function() {
        });
    },
  }
};
</script>

<style>

/*
@import "../../public/css/animations.css";

@import "../../public/css/style.css";
*/

</style>